import React from 'react';
import { Icon, Select, SelectProps } from '@chakra-ui/react';
import { FiChevronDown } from 'react-icons/fi';

interface iSelectProps extends SelectProps {
  options: {
    id: string | number;
    label: string | JSX.Element;
    value: string | number;
  }[];
}

const BlgSelect = ({ options, ...props }: iSelectProps) => {
  const defaultStyle: SelectProps = {
    borderRadius: 'full',
    bg: 'white',
    fontWeight: 700,
    color: 'darkBlue.500',
    _focusVisible: {
      borderColor: 'darkBlue.500',
    },
    _placeholder: {
      color: 'darkBlue.500',
      opacity: 0.5,
    },
    icon: <Icon as={FiChevronDown} color="gray !important" />,
  };

  return (
    <Select {...defaultStyle} {...props}>
      {options.map((option) => (
        <option value={option.value} key={option.id}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export default BlgSelect;
